import { BcmCostCenter } from '@shared/models/bcm-cost-center';

export function sortCostCentersByName(costCenters: BcmCostCenter[]): BcmCostCenter[] {
    if (!costCenters) {
        return [];
    }
    return [...costCenters].sort((left, right) =>
        (left.name ?? '').localeCompare(right.name ?? '', 'de', { sensitivity: 'base' }),
    );
}
